<template>
	<div>
		<div class="xqlist">
			   <div class="liebiao1" v-for="item in list" :key="item" @click="datails(item.d_id)">
					<div class="title">
						<h4 class="titleh4">{{item.demand.name}}</h4>
						<span v-if="item.demand.status==1">报价中</span>
						<span v-if="item.demand.status==2" style="color:#4DC800;">已结束</span>
	<!-- 					<span v-if="item.type==3" style="color:#666666;">平台下架</span> -->
					</div>
					<div class="titleTiem">
						<img src="@/assets/tiem.png" alt="" srcset="" />
						<span>发布时间：{{item.create_time}}</span>
					</div>
					<div class="hylist">
						<div  v-for="(i) in item.demand.industries" :key="i">{{i}}</div>
					</div>
					<div class="hybox">
						<span>{{ item.demand.description}}</span>
					</div>
					<div class="hytiem">
						<span>报价剩余时间：</span>
						<CountDown <CountDown :endTime="item.expire_time * 1000"></CountDown>
					</div>
					<div class="hyfooter">
                        <div class="hyfooter1" v-if="item.status==0">不参与</div>
						<div class="hyfooter2" v-if="item.status==0">立即报价</div>
						<div class="hyfooter3"  v-if="item.status==1" :class="{'yaonioa':item.status==1}">已参与</div>
						<div class="hyfooter4" v-if="item.status==-1" :class="{'yaonioa':item.status==-1}">已拒绝</div>
					</div>
			   </div>
		</div>
	</div>
</template>

<script>
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
	  		CountDown  
	  },
	  data() {
	    return {
		   
	    }
	  },
	  props:{
		  list:{}
	  },
	  methods: {
		datails(e){
			const targetPath = '/serviceHome/invitedList/invitedDatails?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>

<style scoped>
	.xqlist{
			width:1200px;
			margin: 0 auto;
			display:flex;
	/* 		justify-content:space-between; */
			flex-wrap:wrap;
		}
		.xqlist>div:nth-child(3n){
			margin-right:0px;
		}
		.liebiao1{
			width:384px;
			height:247px;
			background: #FFFFFF;
			box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
			border-radius: 12px;
			margin-bottom:24px;
			margin-right:24px;
			padding:12px;
			box-sizing: border-box;
			cursor:pointer;
			transition: all 0.3s;
		}
		.liebiao1:hover{
			transform: scale(1.03);
		}
		.title{
			width:100%;
			display:flex;
			justify-content:space-between;
		}
		.titleh4{
			width:260px;
			overflow: hidden; 
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.title span{
			color:#1E3A8A;
		}
		.titleTiem{
			width:100%;
			display:flex;
			align-items: center;
		}
		.titleTiem img{
			width:12px;
			height:12px;
			margin-right:5px;
		}
		.titleTiem span{
			font-weight: 400;
			font-size: 12px;
			color: #999999;
		}
		.hylist{
			width:100%;
			overflow: hidden;
		}
		.hylist div{
	        padding:3px 5px;
			box-sizing: border-box;
			background: rgba(66,151,255,0.15);
			border-radius: 4px;
			float: left;
			font-weight: 500;
			font-size: 12px;
			color: #4297FF;
			margin-right:6px;
			margin-top:6px;
		}
		.hybox{
			width:100%;
			height:60px;
			margin-top:5px;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.hytiem{
			width:100%;
			display:flex;
			justify-content:space-between;
			align-items: center;
			margin-top:12px;
			background: #FFF8E5;
			border-radius: 4px 4px 4px 4px;
			padding:5px 8px;
			box-sizing: border-box;
		}
		.hytiem span{
			font-weight: 500;
			font-size: 14px;
			color: #FF5900;
		}
		.hyfooter{
			width:100%;
			display:flex;
			align-items:center;
			justify-content:space-between;
			margin-top:12px;
		}
		.hyfooter1{
			width: 174px;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter2{
			width: 174px;
			height: 32px;
			border-radius: 8px;
			font-size: 14px;
			background: #1E3A8A;
			color: #FFFFFF;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter3{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter4{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: #CCCCCC;
			color:#666666;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.yaonioa{
			width:100% !important;
		}
</style>